import { useTRPCAPI, useTRPCClientAPI, useTRPCMutation, useTRPCQuery } from '../../../../trpc/trpc';

/** One "Never contact" row (music24-api `BlockRow`). */
export interface BlockRow {
  blockUuid: string;
  kind: 'email' | 'domain' | 'playlist' | 'contact';
  label: string;
  createdAt: string;
}

/** A name that Plug pitched, offered when the typed text is a name (music24-api `BlockSuggestion`). */
export interface BlockSuggestion {
  kind: 'contact' | 'playlist';
  uuid: string;
  label: string;
}

export type AddBlockResult =
  | { status: 'added'; block: BlockRow; cancelled: number }
  | { status: 'search'; query: string; suggestions: BlockSuggestion[] };

export type AddBlockInput =
  | { text: string }
  | { kind: 'contact'; workspaceContactUuid: string }
  | { kind: 'playlist'; targetUuid: string };

/** The "Never contact" list of an artist (`outreach.blocks.*`, design outreach-v2 c1). */
export function useBlocks(accountId: number) {
  const trpcAPI = useTRPCAPI();
  const trpcClient = useTRPCClientAPI();
  const query = useTRPCQuery(trpcAPI.outreach.blocks.list.queryOptions({ accountId }, { retry: false }));
  const refetch = () => {
    query.refetch().catch(console.error);
  };
  const add = useTRPCMutation({
    mutationFn: (input: AddBlockInput) =>
      trpcClient.outreach.blocks.add.mutate({ accountId, ...input }) as Promise<AddBlockResult>,
    onSuccess: refetch,
  });
  const remove = useTRPCMutation({
    mutationFn: (blockUuid: string) => trpcClient.outreach.blocks.remove.mutate({ accountId, blockUuid }),
    onSuccess: refetch,
  });
  return {
    blocks: (query.data as BlockRow[] | null | undefined) ?? [],
    addBlock: add.mutateAsync,
    isAdding: add.isPending,
    removeBlock: remove.mutateAsync,
  };
}
